<template>
  <div class="sidebar-layout">
    <aside class="sidebar">
      <slot name="sidebar" />
    </aside>

    <div class="content-area">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sidebar-layout {
  display: grid;
  grid-template-columns: 312px 1fr;
  gap: 32px;
  align-items: flex-start;

  @include vp-1279 {
    display: block;
  }

  > .sidebar {
    position: sticky;
    top: 100px;
    height: fit-content;
    z-index: 10;

    @include vp-1279 {
      display: none;
    }
  }

  > .content-area {
    min-width: 0;
  }
}
</style>
